import styled from 'styled-components';
import { COLOR } from '../../styles/colors';
import StyledText from '../../ui/Text/StyledText';
import { SITE_NAV_BREAK_POINT } from '../SiteNav/SiteNavUtils';

export const StyledSchoolTeamHeader = styled.div<{ $hasRightAction?: boolean }>`
  background-color: ${({ theme }) => theme.colors.nav.header};
  color: ${COLOR.white};
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 8px;

  @media (min-width: ${SITE_NAV_BREAK_POINT}px) {
    padding: 20px;
  }

  ${({ $hasRightAction }) =>
    $hasRightAction
      ? `
        & > :last-child {
          align-self: flex-start;
        }
      `
      : ''};
`;

export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 16px;

  & > :last-child {
    margin-top: 10px;
  }
`;

export const StyledLocation = styled(StyledText)`
  & > :first-child {
    margin-right: 4px;
  }
`;
